import { Address } from './Address'
import { Company } from './Company'
import { Appraisal } from './Appraisal'
import { UserAdmin } from './UserAdmin'
import { ISpecies } from './Species'

export class OperationService {
	public _id: string
	public identification: number
	public appraisal: Appraisal
	public company: Company
	public address: Address
	public createdDate: Date
	public schedulingDate?: Date
	public operator?: UserAdmin
	public status: string
	public refused?: Array<Refused>
	public startDate?: Date
	public conclusionDate?: Date
	public images?: Array<{ url: string; date: Date }>
	public finalConsiderations?: string
	public checked?: boolean
}

export class Refused {
	public operator: UserAdmin
	public date: Date
	public schedulingDate: Date
	public justification: string
}

export class ListOperationServiceHistory {
	public idMongo: string
	public process: string
	public osa: number
	public conclusionDate: string
	public requester: string
	public street: string
	public region: string
	public operator: string
	public operatorIdMongo: string
	public companyServiceProvider: string
	public plantingOpportunityId: string
		public source: 'Avaliação' | 'Inventário' | 'Plantio'
	public fragmented: boolean
	public enableSpecialReport: boolean
	public showFragments: boolean
	public tree: {
	  identification: number,
	  identifier: string
	}
	public evaluationResult: {
	  degreeRisk: string,
	  management: string
	}
	public fragments: Array<{
		id: number;
		conclusionDate: string;
		operator: string;
		operatorIdMongo: string;
		companyProvider: string;
	}>
	public status: string;
}

export class OperationServiceDataToReport{
	idMongo: string;
	fragmentId?: number;
}

export class ListOperationServiceSchedule {
	public idMongo: string
	public process: string
	public osa: number
	public oso: number
	public demandIdentificationOsa: string
	public date: string
	public street: string
	public latitude: number
	public longitude: number
	public region: string
	public operator: string
	public operatorIdMongo: string
	public companyServiceProvider: string
	public schedulingDate: string
	public plantingOpportunityId: string
	public source: 'Avaliação' | 'Inventário' | 'Plantio'
	public status: string
	public fragmented: boolean
	public tree: {
	  identification: number,
	  identifier: string,
		specieId: number;
	}
	public evaluationResult: {
	  degreeRisk: string,
	  management: string
	}
	public cancelRefused: boolean
	public comunicationNumber: string
	public appraisalId: string

	// Only populated on the pre scheduling page
	public specie: ISpecies
}

export class OperationServiceScheduleDetails {
	public idMongo: string
	public os: number
	public categoryRisk: string
	public date: string
	public address: string
	public latitude: number
	public longitude: number
	public scheduleDate: string
	public operator: string
	public companyProvider: string
	public source: 'Avaliação' | 'Inventário' | 'Plantio'
	public fragmented: boolean;
	public refusedFromOperator: boolean;
	public status: string
	public tree: {
		identification: number;
		identifier: string;
		identifierName: string;
		specie: string;
		family: string;
		dapCap: string;
		dapCapType: string;
		height: string;
		createDate: string;
	}
	public treeMedia: string
	public inventorAnswers: Array<{
		evaluation: string;
		answers: Array<string>;
		photo: string;
	}>
	public cancelRefused: boolean
	public handlerOperations: Array<{
	idMongo: string;
	operation: string;
	}>
	public operationRefused: {
    responsible: string;
    date: string;
    reason: string;
    justification: string;
    media: Array<string>;
  };
	public considerations: string
}

export class ImageGaleryOperationService {
		public photo: string
		public evaluation: string
}

export class CoordinatesOperationServiceScheduler {
		public operationScheduler: Array<CoordinatesOperationsService> = []
		public operationCompleted: Array<CoordinatesOperationsService> = []
}

export class CoordinatesOperationsService {
		public idMongo: string
		public schedulingDate: Date
		public operatorId: string
		public operator
		public street: string
		public lat: number
		public lng: number
}

export class QuestionsOperationService {
	public question: string
	public answers: Array<{
		text: string,
		order: number,
		color: string
	}>
}

export class OperationServiceScheduleChacheMap {
	public idMongo: string
	public date: string
	public lat: number
	public lng: number
	public evaluation: string
	public answer: string
	public appraisalId: string
	}
